import appModule from './app.module'

appModule
    .constant("version", env.VERSION)
    .constant("ENV", {
        "name": env.NAME,
        "apiEndpoint": env.API_ENDPOINT,
        "baseurl": env.BASE_URL,
        "storage": env.STORAGE,
        "publicBucketName": env.PUBLIC_BUCKET_NAME,
        "googleApiKey": env.GOOGLE_API_KEY,
        "intercomAppId": env.INTERCOM_APP_ID
    });

